import { CoursePayTypeInfo } from './course';
import { MemberInfo } from './member';

// 班级状态枚举
export enum ClassStatus {
  All = 0, // 全部
  Ongoing = 1, // 进行中
  Ended = 2, // 已结束
}

// 班级详情数据
export type ClassInfo = {
  id: number;
  name: string; // 班级名称
  merchant_id: number; // 商户ID
  teacher_id: number; // 老师ID
  teacher_name: string; // 老师名称
  class_time_intro: string; // 上课时间介绍
  store_id: number; // 店铺ID
  store_name: string; // 店铺名称
  classroom_id: number; // 教室ID
  classroom_name: string; // 教室名称
  max_students: number; // 班级的满班人数
  in_count: number; // 在班人数
  pay_types: CoursePayTypeInfo[]; // 根据实际支付类型结构可以进一步定义
  status: ClassStatus; // 1: 已开班, 2: 已结课
  start_time: string; // 开始时间
  intro: string; // 班级介绍
  creator_id: number; // 创建者uid
  creator_name: string; // 创建者名称
  end_time: string; // 结束时间
  end_operator_id: number; // 结课操作员uid
  end_operator_name: string; // 结课操作员名称
  create_time: string; // 创建时间
  update_time: string; // 更新时间
  difficulty_level: number; // 难度
  dance_style_id: number; // 舞种

  // 班级最后一节课信息
  last_course: {
    id: number;
    name: string; // 课程名称
    start_time: string;
    end_time: string;
  };
  upgrade_attendance_threshold: number; // 升班出勤阈值 0: 不设置, 其他: 出勤次数
  promotable_count: number; // 可升班人数
};

// 班级学员信息
export type ClassStudentInfo = {
  absence_count: number; // 缺勤次数
  attendance_count: number; // 出勤次数
  class_id: number; // 班级ID
  class_name: string; // 班级名称
  create_time: string; // 创建时间
  end_time: string; // 结束时间
  id: number; // 学员ID
  join_time: string; // 加入时间
  leave_count: number; // 请假次数
  status: number; // 状态 1: 在班 2: 结课
  update_time: string; // 更新时间
  user_id: number; // 用户ID
  user_info: MemberInfo; // 用户信息
  is_promotable: number; // 是否可升班 1: 是 其他: 否
};

// 新建班级请求参数
export type CreateClassParams = {
  // 教室id
  classroom_id: number;
  // 最大人数
  max_students: number;
  // 支付信息
  pay_types: {
    member_card_type_name: string;
    payment_type: number;
    pay_num: number;
    member_card_type_id: number;
  }[];
  // 开始时间
  start_time: string;
  // 老师id
  teacher_id: number;
  // 介绍
  intro: string;
  // 门店id
  store_id: number;
  // 班级名
  name: string;
  // 时间介绍
  class_time_intro: string;
  // 状态
  status?: ClassStatus;
  difficulty_level: number; // 难度
  dance_style_id?: number; // 舞种
  upgrade_attendance_threshold?: number; // 升班条件：到课满X次
};
